import { Button } from '@abyss/web/ui/Button';
import React from 'react';

interface SignInProps {
  url: string | null;
  text: string;
}

export const SignIn: React.FC<SignInProps> = ({ text, url }) => (
  <Button
    data-auto-testid="guest-header-sign-in-button"
    data-testid="guest-header-sign-in-button"
    onClick={() => {
      if (!url) {
        // eslint-disable-next-line no-console
        console.error('Sign-in URL null');
      } else {
        window.location.href = url;
      }
    }}
    size="$md"
    variant="outline"
  >
    {text}
  </Button>
);
